<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 20 20" :width="width" :height="height" style="enable-background:new 0 0 20 20;" xml:space="preserve">
        <rect class="st0" width="20" height="20" opacity="0"/>
        <g>
	<g>
		<g>
			<g>
				<g>
					<path class="svg-secondary-color" d="M17.6,20H2.4c-0.9,0-1.5-0.7-1.5-1.5c0-3.5,1.9-6.7,5-8.3C4.9,9.1,4.4,7.6,4.4,6.1C4.4,2.8,6.9,0,10,0
						s5.6,2.8,5.6,6.1c0,1.5-0.5,3-1.4,4.1c3,1.6,5,4.8,5,8.3C19.2,19.3,18.5,20,17.6,20z M10,1C7.4,1,5.4,3.3,5.4,6.1
						C5.4,7.6,5.9,9,7,10l0.5,0.5l-0.7,0.3c-3,1.3-5,4.3-5,7.6c0,0.3,0.2,0.5,0.5,0.5h15.3c0.3,0,0.5-0.2,0.5-0.5c0-3.3-2-6.3-5-7.6
						l-0.7-0.3L13,10c1-1,1.6-2.4,1.6-3.9C14.6,3.3,12.6,1,10,1z"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>
</template>

<script>
export default {
    name: "usernameIcon",
    props: {
        width: {
            type: Number,
            default: 20,
        },
        height: {
            type: Number,
            default: 20
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/usernameIcon.vue